import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  success: "",
  user: {},
  loading: true, // Empezamos en true para la carga inicial
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data;
      state.loading = false; // La carga terminó con éxito
    },
    profileError(state, action) {
      state.error = action.payload;
      state.loading = false; // La carga terminó con error
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    editProfileChange(state) {
      state = { ...state };
    },
    resetProfileFlagChange(state: any) {
      state.success = null;
    },
  },
});

export const {
  profileSuccess,
  profileError,
  setLoading,
  editProfileChange,
  resetProfileFlagChange,
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
